import React, {Component, useEffect, useState} from 'react';
import Dropdown from "../../cmp/Dropdown";
import * as localStorage from "../../../tools/storage";
import {connect} from "react-redux";
import {loadSites} from "../../../redux/sites/sitesActions";
import {getAccessToken} from '../../../api';

function StoreSwitcher({loadSites, sites}) {
    useEffect(()=>{
       loadSites()
    },[loadSites])

    const handleSelection = (opt) => {
        window.location = `${opt.value}/login-as/${getAccessToken()}`;
    }
    const selected = sites.find(({value})=>{
        return new URL(value).hostname === document.location.hostname
    })

    return (<>
        {
           sites.length > 1 &&
                <div id={"store-switcher"} style={{position: 'absolute', top: 0, right: 0}}>
                    <Dropdown opts={sites}
                              selected={selected}
                              onSelected={handleSelection}/>
                </div>
        }
    </>);
}

function mapStateToProps(state){
    return {
        sites: state.sites.map((item)=>{
            return {
                label:item.name,
                value: item.affiliate_portal
            }
        })
    }
}

function mapDispatchToProps(dispatch){
    return {
        loadSites: () => dispatch(loadSites())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(StoreSwitcher);
